export const routes = {
  login: "login",
  emailSignup:"email-signup",
  emailLogin:"email-login",

  otp: "otp",
  emailotp: "emailotp",
  emailloginotp: "email-login-otp",
  avatar: "avatar",
  home: "home",
  gameTournament: "tournaments",
  tournamentDetails: "tournament-details/:id",
  worldOfEsports: "world-of-esports",
  news: "esports-news",
  newsDetails: "news-details",
  topProfiles: "top-profile",
  popularVideos: "popular-video",
  myContest: "my-contest",
  privateContest: "private-contest",
  leaderBoard: "leader-board",
  managePrivateContest: "manage-contest/:id",
  gameContest: "contest",
  contestDetails: "contest-details/:id",
  signupotp: "signupotp",
  coinStore: "coin-store",
  createPrivateContest: "create-contest",
  editPrivateContest: "edit-contest/:id",
  customerCare: "customer-care",
  raiseACompaint: "raise-a-complaint",

  rewardStore: "reward-store",
  scrimDetails: "scrim-details/:id",
  freeGames: "free-games",
  legality: "legality",
  myProfile: "my-profile",
  paymentStatus: "payment-status",
  ticketDetails:'ticket-details/:id',
  getSubscriptionTypeList:'get-premium',
  paymentStatusSubscription: "payment-status-subscription",
  userProfile:"user-profile/:id",
  landingPAge:'landing-page',
  contact:'contact',
  about:'about',
  termsAndCondition:'termsAndCondition',
  policy:'policy',
  payuPaymentStatus:"payment-status-payu",
  easebuzzPaymentStatus:"payment-status-easebuzz"
};
